import { useEffect } from 'react';
import useIntersection from 'src/lib/Hooks/useIntersection';
import { ImagesType, RebateOrOfferType } from '../..';

type RebateProps = {
  isPrimary: boolean;
  btn?: string;
  rebate: RebateOrOfferType;
  setSelectedOffer: React.Dispatch<React.SetStateAction<RebateOrOfferType>>;
  setIntersection: () => void;
  shouldZoom: boolean;
  shouldAdjustRow: boolean;
  images?: ImagesType;
};

const RebateImage = ({ offerCode, img, images, defaultMeasureCategory }: any) => {
  const imgSrc = offerCode
    ? `/_/media/Images/Apps/find it duke/${offerCode}`
    : images
    ? images[defaultMeasureCategory].card
    : img;
  return (
    <img
      className="object-cover aspect-16/9 w-full h-auto rounded-t-md bg-gray-light"
      src={imgSrc}
      sizes="(min-width: 1280px) 384px, (min-width: 1024px) 316px, (min-width: 768px) 230px, 316px"
      alt=""
      width="384"
      height="216"
      loading="lazy"
    />
  );
};

const Rebate = ({
  rebate,
  images,
  shouldAdjustRow = false,
  btn = 'Rebate Details',
  setSelectedOffer,
  shouldZoom,
  setIntersection,
  ...rest
}: RebateProps) => {
  const { isIntersecting, ref } = useIntersection<HTMLDivElement>({ threshold: 0.6 }, false);
  useEffect(() => {
    isIntersecting && setIntersection();
  }, [isIntersecting]);
  return (
    <li
      className={`snap-center flex-shrink-0 sm:px-4 md:p-8 lg:p-12 w-11/12 sm:w-7/12 md:w-1/3 max-w-xs md:max-w-none ${
        shouldAdjustRow ? 'md:ml-px' : ''
      }`}
    >
      <div
        ref={ref}
        className={`relative flex flex-col w-full h-full rounded-md shadow md:hover:shadow-md bg-white transition-all duration-300 md:will-change-transform transform md:over:-translate-y-4 ${
          shouldZoom ? 'scale-100' : 'scale-90'
        } md:scale-100`}
      >
        {rebate && (
          <>
            <RebateImage
              img={rebate.img}
              offerCode={rebate.code}
              images={images}
              defaultMeasureCategory={rebate.defaultMeasureCategory}
            />

            <div className="flex flex-col flex-1 justify-between p-24 md:p-16 lg:p-24">
              <div>
                <span className="text-xs font-bold uppercase">{rebate.rebate}</span>
                <p className="mt-8 text-xl text-gray-dark">
                  <a className="" target="_blank" href={rebate.learnMore} rel="noreferrer">
                    {rebate.title}
                  </a>
                </p>
              </div>
              <p className="mt-16" aria-hidden="true">
                <button
                  onClick={() => setSelectedOffer({ ...rebate, ...rest })}
                  className="btn btn-primary btn-static btn-full"
                >
                  {btn}
                </button>
              </p>
            </div>
          </>
        )}
      </div>
    </li>
  );
};

export default Rebate;
export { type RebateProps };
